import React, { useEffect, useState } from "react";
import { getPetrolPrices, setPetrolPrices } from "services/firebase";

export default function Petrol() {
  const [data, setData] = useState([]);
  useEffect(() => {
    getPetrolPrices(setData);
  }, []);
  const handleChangeData = (key, index) => (e) => {
    data[index][key] = e.target.value;
    setData([...data]);
  };
  const addData = () => {
    data.push({
      name: "",
      Regular: "",
      Premium: "",
    });
    setData([...data]);
  };
  const save = () => {
    setPetrolPrices(data);
  };
  console.log(data);
  return (
    <div>
      petrol
      {data.map((elem, index) => {
        return (
          <div>
            <snap>
              Name
              <input
                value={elem.name}
                onChange={handleChangeData("name", index)}
              />{" "}
            </snap>
            <snap>
              Regular
              <input
                value={elem.Regular}
                onChange={handleChangeData("Regular", index)}
              />
            </snap>
            <snap>
              Premium
              <input
                value={elem.Premium}
                onChange={handleChangeData("Premium", index)}
              />
            </snap>
          </div>
        );
      })}
      <button onClick={addData}>+</button>
      <button onClick={save}>save</button>
    </div>
  );
}
